// ===========================================
// Safe URL rule (frontend mirror of apps/backend/src/utils/safeUrl.ts)
// ===========================================
// https only, with a host and no credentials. The backend validator AND service
// enforce the same rule; this copy only gives the dialog live feedback.

export const MAX_URL_LENGTH = 2048;

export function isSafeHttpsUrl(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed || trimmed.length > MAX_URL_LENGTH) return false;
  let url: URL;
  try {
    url = new URL(trimmed);
  } catch {
    return false;
  }
  // Length is judged on the normalised form, as the server does (a unicode path expands).
  return url.protocol === 'https:' && !!url.hostname && !url.username && !url.password && url.href.length <= MAX_URL_LENGTH;
}
